import { cn } from '@/core/utils/common'

/**
 * 워드마크 — 홈 시안 A 의 로고 결(Pretendard 가장 굵게 · 자간 좁게 + 코랄 마침표).
 * 머리줄 · 상단 내비 · 메뉴 서랍이 같은 부품을 쓴다. 크기는 쓰는 쪽이 text-* 로 정한다.
 */
export default function Logo({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-baseline font-sans leading-none font-black tracking-[-0.04em] text-t1',
        className
      )}
    >
      veluvit<span className="text-point">.</span>
    </span>
  )
}
